import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5Z",
  fill: "currentColor"
}));
export default SvgHome;